import script from "./TenantRequestsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantRequestsView.vue?vue&type=script&setup=true&lang=js"

import "./TenantRequestsView.vue?vue&type=style&index=0&id=f81a146c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f81a146c"]])

export default __exports__